<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstClassAttendanceStudent"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedClassAttendanceStudent"
		dataKey="ClassAttendanceStudentID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--CourseCD-->
				<th>
					<p-columnFilter field="CourseCD" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterCourseCD
								[ngModel]="value"
								[options]="lstCourseCD"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--SectionNo-->
				<th>
					<p-columnFilter field="SectionNo" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterSectionNo
								[ngModel]="value"
								[options]="lstSectionNo"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--PeriodNo-->
				<th>
					<p-columnFilter field="PeriodNo" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterPeriodNo
								[ngModel]="value"
								[options]="lstPeriodNo"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--RoomNo-->
				<th>
					<p-columnFilter field="RoomNo" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterRoomNo
								[ngModel]="value"
								[options]="lstRoomNo"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--StudentName-->
				<th>
					<p-columnFilter type="text" field="StudentName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--ClassAttendanceStatusDesc-->
				<th>
					<p-columnFilter field="ClassAttendanceStatusDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterClassAttendanceStatusDesc
								[ngModel]="value"
								[options]="lstClassAttendanceStatusDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--ClassAttendanceExcuseDesc-->
				<th>
					<p-columnFilter field="ClassAttendanceExcuseDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterClassAttendanceExcuseDesc
								[ngModel]="value"
								[options]="lstClassAttendanceExcuseDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--EntryTime-->
				<th>
					<!-- <p-columnFilter type="text" field="EntryTime" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--ExitTime-->
				<th>
					<!-- <p-columnFilter type="text" field="ExitTime" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--EntryDate-->
				<th>
					<!-- <p-columnFilter type="text" field="EntryDate" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--SubmittedDT-->
				<th>
					<!-- <p-columnFilter type="text" field="SubmittedDT" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--LastEditedBy-->
				<th>
					<p-columnFilter type="text" field="LastEditedBy" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="CourseCD">Course<p-sortIcon field="CourseCD"></p-sortIcon></th>
				<th pSortableColumn="SectionNo">Section<p-sortIcon field="SectionNo"></p-sortIcon></th>
				<th pSortableColumn="PeriodNo">Period<p-sortIcon field="PeriodNo"></p-sortIcon></th>
				<th pSortableColumn="RoomNo">Room<p-sortIcon field="RoomNo"></p-sortIcon></th>
				<th pSortableColumn="StudentName">Student<p-sortIcon field="StudentName"></p-sortIcon></th>
				<th pSortableColumn="ClassAttendanceStatusDesc">Status<p-sortIcon field="ClassAttendanceStatusDesc"></p-sortIcon></th>
				<th pSortableColumn="ClassAttendanceExcuseDesc">Excuse<p-sortIcon field="ClassAttendanceExcuseDesc"></p-sortIcon></th>
				<th pSortableColumn="EntryTime">Entry Time<p-sortIcon field="EntryTime"></p-sortIcon></th>
				<th pSortableColumn="ExitTime">Exit Time<p-sortIcon field="ExitTime"></p-sortIcon></th>
				<th pSortableColumn="EntryDate">Entry Date<p-sortIcon field="EntryDate"></p-sortIcon></th>
				<th pSortableColumn="SubmittedDT">Last Updated<p-sortIcon field="SubmittedDT"></p-sortIcon></th>
				<th pSortableColumn="LastEditedBy">Last Updated By<p-sortIcon field="LastEditedBy"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-ClassAttendanceStudent>
			<tr [pSelectableRow]="ClassAttendanceStudent" (dblclick)="onRowDblClick(ClassAttendanceStudent)">
				<td *ngFor="let col of cols1" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ ClassAttendanceStudent[col.field] }}
				</td>

				<td
					style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
					[style.color]="ClassAttendanceStudent.IsCountAsPresent == true ? 'Black' : 'Red'"
				>
					{{ ClassAttendanceStudent["ClassAttendanceStatusDesc"] }}
				</td>

				<td *ngFor="let col of cols2" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ ClassAttendanceStudent[col.field] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<div class="Buttons">
	<button class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
